/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path:first-of-type {
    fill: #4285f4 !important;
  }
  path:nth-of-type(2) {
    fill: #34a853 !important;
  }
  path:nth-of-type(3) {
    fill: #fbbc05 !important;
  }
  path:nth-of-type(4) {
    fill: #ea4335 !important;
  }
  path:last-of-type {
    fill: none !important;
  }
`

export default class GoogleIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80.003" viewBox="0 0 80 80.003" css={Color}>
          <g id="logo_googleg_48dp" transform="translate(0 0.003)">
            <path id="Shape" className="blue" d="M47.4,15.545a45.988,45.988,0,0,0-.727-8.182H9V22.836H30.527a18.4,18.4,0,0,1-7.982,12.073V44.945H35.473C43.036,37.982,47.4,27.727,47.4,15.545Z" transform="translate(31 25.364)" fill="#4285f4" fillRule="evenodd" />
            <path id="Shape-2" className="green" data-name="Shape" d="M36.7,43.11c10.8,0,19.855-3.582,26.473-9.691L50.248,23.383A24.042,24.042,0,0,1,36.7,27.2,23.839,23.839,0,0,1,14.321,10.71H.957V21.074A39.985,39.985,0,0,0,36.7,43.11Z" transform="translate(3.297 36.89)" fill="#34a853" fillRule="evenodd" />
            <path id="Shape-3" className="yellow" data-name="Shape" d="M17.618,30.522a23.648,23.648,0,0,1,0-15.2V4.958H4.255a40.05,40.05,0,0,0,0,35.927Z" transform="translate(0 17.078)" fill="#fbbc05" fillRule="evenodd" />
            <path id="Shape-4" className="red" data-name="Shape" d="M36.7,15.909a21.609,21.609,0,0,1,15.291,5.982L63.466,10.418A38.442,38.442,0,0,0,36.7,0,39.985,39.985,0,0,0,.957,22.036L14.321,32.4A23.839,23.839,0,0,1,36.7,15.909Z" transform="translate(3.297)" fill="#ea4335" fillRule="evenodd" />
            <path id="Shape-5" data-name="Shape" d="M0,0H80V80H0Z" fill="none" fillRule="evenodd" />
          </g>
        </svg>

      </Fragment>
    )
  }
}
